module.exports = __webpack_public_path__ + "img/presintation.075b48dd.gif";